export default __webpack_public_path__ + "static/media/gw13.c66a8f8a.webp";